export const getCardNumberEnding = (cardNumber) => {
    const parts = cardNumber.trim().split(' ');
    const ending = parts[parts.length - 1];
    return ending;
};
//# sourceMappingURL=get-card-number-ending.js.map